<template>
  <div class="payment">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('payment.edit')"
      :visible.sync="dialogPayment"
      width="850px"
      top="6vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form :label-position="labelPosition" ref="payment" label-width="80px" :model="payment.payConfig">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('payment.coin')" prop="isCoin">
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:iscoin')"
                  v-model="payment.payConfig.isCoin"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="payment.payConfig.isCoin == 1" :span="12">
              <el-form-item :label="$t('payment.coinAcceptor')" prop="coinType">
                <el-select
                  v-model="payment.payConfig.coinType"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option
                    v-for="item in coinAcceptorItem"
                    :key="item.id"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('payment.banknote')" prop="isBill">
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:isbill')"
                  v-model="payment.payConfig.isBill"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="payment.payConfig.isBill == 1" :span="12">
              <el-form-item :label="$t('payment.billType')" prop="billType">
                <el-select
                  v-model="payment.payConfig.billType"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option
                    v-for="item in billAcceptorItem"
                    :key="item.id"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('payment.creditCard')" prop="isCard">
                <el-select
                  v-model="payment.payConfig.isCard"
                  :disabled="$tools.IsGrayModule('usermahcine:gray:iscard')"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="payment.payConfig.isCard == 1" :span="12">
              <el-form-item :label="$t('payment.cardReader')" prop="cardType">
                <el-select
                  v-model="payment.payConfig.cardType"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option
                    v-for="item in shuaKaQi"
                    :key="item.id"
                    :label="item.label"
                    :value="+item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('payment.isPaypal')" prop="isPaypal">
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:ispaypal')"
                  v-model="payment.payConfig.isPaypal"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('user.Payment.148264-0')" prop="isNaYax">
                <el-select
                  v-model="payment.payConfig.isNaYax"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                v-if="payment.payConfig.isNaYax == 1"
                :label="$t('user.Payment.148264-1')"
                prop="nayaxQrCode"
              >
                <CustomUploadImg
                  :url.sync="payment.payConfig.naYaxQrCode"
                  :action="uploadFeedbackUrl"
                  :headers="headers"
                  :accept="'.jpg,.png'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('user.Payment.148264-2')" prop="nayaxQrCode">
                <el-select
                  v-model="payment.payConfig.isFree"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('payment.isCoinReturn')" prop="isCoinRefund">
                <el-select
                  :disabled="$tools.IsGrayModule('usermahcine:gray:iscoinrefund')"
                  v-model="payment.payConfig.isCoinRefund"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  :placeholder="$t('payment.select')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="8">
							<el-form-item :label="$t('payment.Redemption')" prop="isFree">
								<el-select
									:disabled="$tools.IsGrayModule('usermahcine:gray:isfree')"
									v-model="payment.payConfig.isFree"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									:placeholder="$t('payment.select')">
									<el-option
										v-for="item in yesNo"
										:key="item.id"
										:label="item.label"
										:value="+item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')" size="small">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('payment')" size="small">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import CustomUploadImg from "@/components/CustomUploadImg.vue";
  import config from "@/http/config";

  export default {
    name: "Payment",
    components: {
      CustomUploadImg
    },
    props: {
      dialogPayment: Boolean,
      payment: Object,
      yesNo: Array,
      shuaKaQi: Array,
      coinAcceptorItem: Array,
      billAcceptorItem: Array,
      isBatch: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        labelPosition: "top",
        loadingForm: false,
        uploadFeedbackUrl: config.baseUrl + this.$url.Upload.feedback,
        headers: {
          token: this.$cookies.get("token")
        }
      };
    },
    methods: {
      closeDialog() {
        this.cancel("");
      },

      openDialog() {
        console.log(this.payment, "payment");
      },

      cancel(state) {
        this.$emit("cancelPayment", false, state);
      },

      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let url = null;
            if (this.isBatch) {
              url = this.$url.UserMachine.setPaymentTeam;
            } else {
              url = this.$url.UserMachine.payment;
            }
            this.loadingForm = true;
            this.$api
              .request(url, this.$method.put, this.payment)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.cancel(this.payment.id ? "update" : "save");
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: #409eff;
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__body {
      padding: 20px 20px 0 20px;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
</style>
